import commonApi from '@/api/api.common'
import i18n from '@/locales/index'
export default [
  {
    type: 'select',
    placeholder: i18n.t('RecipeManage.typeRecipeType'),
    filed: 'id',
    default: '',
    query: commonApi.cookbook_type_select
  },
  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    startplh: i18n.t('Common.startTime'),
    endplh: i18n.t('Common.endTime')
  }
]
